export function navigateToNextField(field: number, isDown: boolean) {
    window['priInputDlg'] &&
        window['priInputDlg'].navigateToNextField &&
        window['priInputDlg'].navigateToNextField(field, isDown);
}

export function onFieldFocus(field: number, inputIdx: number) {
    window['priInputDlg'] &&
        window['priInputDlg'].onFieldFocus &&
        window['priInputDlg'].onFieldFocus(field, inputIdx);
}

export function invokeF9Handler(save: boolean, field: number, inputIdx: number) {
    window['priInputDlg'] &&
        window['priInputDlg'].invokeF9Handler &&
        window['priInputDlg'].invokeF9Handler(save, field, inputIdx);
}
